module.exports = __webpack_public_path__ + "static/media/Didari-white.d1318c34.svg";